"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureTag = void 0;
exports.featureTag = [
    {
        id: 1,
        name: 'Android Auto',
        category: 'Technology',
        regex: /(?=^.*android)/i,
        start_year: 2014,
        searchable: true,
    },
    {
        id: 2,
        name: 'Apple CarPlay',
        category: 'Technology',
        regex: /(?=^.*apple)(?=^.*car play)/i,
        start_year: 2014,
        searchable: true,
    },
    {
        id: 3,
        name: 'Backup Camera',
        category: 'Safety',
        regex: /(((?=^.*back?[ -]?up)|(?=^.*rear)|(?=^.*reversing)|(?=^.*around))(?=^.*camera))|rear?[ -]?view.*monitor/i,
        start_year: 2007,
        searchable: true,
    },
    {
        id: 4,
        name: 'Surround View Camera',
        category: 'Safety',
        regex: /(surround\s+view)/i,
        start_year: 2007,
        searchable: true,
    },
    {
        id: 5,
        name: 'Dash Camera',
        category: 'Safety',
        regex: /(dash\s+camera)/i,
        start_year: 2007,
        searchable: true,
    },
    {
        id: 6,
        name: 'Blind Spot Monitor',
        category: 'Safety',
        regex: /(?=^.*blind.spot)((?=^.*display)|(?=^.*camera)|(?=^.*alert)|(?=^.*blind.spot)|(?=^.*safety))|autopilot|(?=^.*side)(?=^.*camera)/i,
        start_year: 2007,
        searchable: true,
    },
    {
        id: 7,
        name: 'Collision Avoidance',
        category: 'Safety',
        regex: /(?=^.*collision)((?=^.*pre-)|(?=^.*warning)|(?=^.*avoidance)|(?=^.*notif))|pre?[ -]?sense|driving.assistant|emergency.braking|pre?[ -]?safe|eyesight|autopilot/i,
        start_year: 1996,
        searchable: true,
    },
    {
        id: 8,
        name: 'Lane Departure Warning',
        category: 'Safety',
        regex: /(?=^.*lane)((?=^.*departure)|(?=^.*deviation)|(?=^.*assist)|(?=^.*keep))|autopilot/i,
        start_year: 2002,
        searchable: true,
    },
    {
        id: 9,
        name: 'Lane Keeping Assistance',
        category: 'Safety',
        regex: /(?=^.*lane)|(?=^.*keeping)|autopilot/i,
        start_year: 2002,
        searchable: true,
    },
    {
        id: 10,
        name: 'Adaptive Cruise Control',
        category: 'Convenience',
        regex: /((?=^.*adaptive)|(?=^.*adaptive stop and go)|(?=^.*active)|(?=^.*dynamic)|(?=^.*radar)|(?=^.*intelligent)|(?=^.*traffic?[ -]?aware))(?=^.*cruise)|autopilot /i,
        start_year: 2010,
        searchable: true,
    },
    {
        id: 11,
        name: 'Parking Sensors',
        category: 'Convenience',
        regex: /park.*sensor/i,
        start_year: 1983,
        searchable: true,
    },
    {
        id: 12,
        name: 'Night View',
        category: 'Safety',
        regex: /(night\s+view)|(night\s+vision)/i,
        start_year: 2003,
        searchable: true,
    },
    {
        id: 13,
        name: 'Tire Pressure Monitoring',
        category: 'Safety',
        regex: /tire.*monitor/i,
        start_year: 1986,
        searchable: true,
    },
    {
        id: 14,
        name: 'Head-Up Display',
        category: 'Convenience',
        regex: /heads?[ -]?up[ ]?display|HUD/i,
        start_year: 1988,
        searchable: true,
    },
    {
        id: 15,
        name: 'Heated Mirrors',
        category: 'Exterior',
        regex: /(?=^.*heat)(?=^.*mirror)/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 16,
        name: 'Rain Sensing Wipers',
        category: 'Convenience',
        regex: /(?=^.*rain)(?=^.*sens)(?=^.*wiper)/i,
        start_year: 1950,
        searchable: true,
    },
    {
        id: 17,
        name: 'Automatic Climate Control',
        category: 'Convenience',
        regex: /((?=^.*climate)|(?=^.*temperature))(?=^.*auto)/i,
        start_year: 1960,
        searchable: true,
    },
    {
        id: 18,
        name: 'Power Sliding Doors',
        category: 'Convenience',
        regex: /(?=^.*power)(?=^.*sliding)(?=^.*door)/i,
        start_year: 1960,
        searchable: true,
    },
    {
        id: 19,
        name: 'Remote Start',
        category: 'Convenience',
        regex: /(?=^.*remote)(?=^.*start)/i,
        start_year: 1968,
        searchable: true,
    },
    {
        id: 22,
        name: 'Cross Traffic Alert',
        category: 'Safety',
        regex: /cross traffic/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 23,
        name: 'Bluetooth',
        category: 'Entertainment',
        regex: /bluetooth/i,
        start_year: 2001,
        searchable: true,
    },
    {
        id: 24,
        name: 'Navigation',
        category: 'Technology',
        regex: /(?=^.*navigation)(?!^.*optional)(?!^.*if.equipped)/i,
        start_year: 1995,
        searchable: true,
    },
    {
        id: 25,
        name: 'Premium Audio',
        category: 'Entertainment',
        regex: /(?=^.*premium)((?=^.*speaker)|(?=^.*audio)|(?=^.*sound)|(?=^.*brand)|(?=^.*krell))|musicgate.*sound|1[0-9].speaker|surround.sound|(?=^.*speakers:)((?=^.[7-9])|(?=^.*[1-3][0-9]))/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 26,
        name: 'Satellite Radio',
        category: 'Entertainment',
        regex: /satellite.*radio|sirius/i,
        start_year: 2004,
        searchable: true,
    },
    {
        id: 27,
        name: '115V Power Outlet',
        category: 'Convenience',
        regex: /(?=^.*115v)(?=^.*outlet)/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 28,
        name: 'Air Suspension',
        category: 'Other',
        regex: /(?=^.*air)(?=^.*suspension)/i,
        start_year: 1981,
        searchable: false,
    },
    {
        id: 29,
        name: 'Heated Seats',
        category: 'Comfort & Seating',
        regex: /(?=^.*heat)(?=^.*seat)/i,
        start_year: 1966,
        searchable: true,
    },
    {
        id: 30,
        name: 'Cooled Seats',
        category: 'Comfort & Seating',
        regex: /(?=^.*cool)(?=^.*seat)/i,
        start_year: 2007,
        searchable: true,
    },
    {
        id: 31,
        name: 'Ventilated Seats',
        category: 'Comfort & Seating',
        regex: /(?=^.*ventilated)(?=^.*seat)/i,
        start_year: 2007,
        searchable: true,
    },
    {
        id: 32,
        name: 'Memory Seats',
        category: 'Comfort & Seating',
        regex: /(?=^.*memory)(?=^.*seat)/i,
        start_year: 1993,
        searchable: true,
    },
    {
        id: 33,
        name: 'Power Seats',
        category: 'Comfort & Seating',
        regex: /(?=^.*power)(?=^.*seat)/i,
        start_year: 1950,
        searchable: true,
    },
    {
        id: 34,
        name: 'Premium Wheels',
        category: 'Exterior',
        regex: /(?=^.*premium)(?=^.*wheel)/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 35,
        name: 'Sunroof/Moonroof',
        category: 'Exterior',
        regex: /sunroof|moonroof|(?=^.*panoramic)(?=^.*roof)/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 36,
        name: 'Tinted Windows',
        category: 'Exterior',
        regex: /((?=^.*window)|(?=^.*glass))((?=^.*privacy)|(?=^.*tint))/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 37,
        name: 'Garage Door Opener',
        category: 'Convenience',
        regex: /garage?[ -]?door|homelink/i,
        start_year: 1900,
        searchable: true,
    },
    {
        id: 38,
        name: 'Adjustable Pedals',
        category: 'Convenience',
        regex: /adjustable.*pedals/i,
        searchable: true,
    },
    {
        id: 39,
        name: 'Towing Package',
        category: 'Convenience',
        regex: /towing.*package/i,
        searchable: true,
    },
    {
        id: 40,
        name: 'Driving Assistant',
        category: 'Safety',
        regex: /(?=^.*assistant)(?=^.*driving)/i,
        searchable: true,
    },
    {
        id: 41,
        name: 'Self Driving',
        category: 'Convenience',
        regex: /self[-\s]?driving|autonomous(?:[-\s]?driving)?|driverless|autopilot|full[-\s]?self[-\s]?driving/i,
        start_year: 2020,
        searchable: false,
    },
    {
        id: 42,
        name: 'Autonomous Braking',
        category: 'Safety',
        regex: /((?=^.*automatic)|(?=^.*autonomous))(?=^.*braking)/i,
        start_year: 2010,
        searchable: true,
    },
    {
        id: 43,
        name: 'Remote Parking Assist',
        category: 'Convenience',
        regex: /(?=^.*parking)(?=^.*assist)/i,
        start_year: 2016,
        searchable: true,
    },
    {
        id: 44,
        name: 'Exit Safety System',
        category: 'Safety',
        regex: /(?=^.*exit)(?=^.*safety)/i,
        searchable: true,
    },
    {
        id: 45,
        name: 'Automatic Emergency Braking',
        category: 'Safety',
        regex: /((?=^.*automatic)|(?=^.*emergency))(?=^.*braking)/i,
        start_year: 2006,
        searchable: true,
    },
    {
        id: 46,
        name: 'Self Parking',
        category: 'Convenience',
        regex: /(?=^.*remote parking)|(?=^.*active parking system)/i,
        start_year: 2018,
        searchable: true,
    },
    {
        id: 47,
        name: 'Heated Steering Wheel',
        category: 'Comfort & Seating',
        regex: /(?=^.*heated)(?=^.*steering)/i,
        start_year: 1980,
        searchable: true,
    },
    {
        id: 48,
        name: 'Trailer Hitch',
        category: 'Other',
        regex: /trailer[-\s]?hitch/i,
        start_year: 1981,
        searchable: true,
    },
    {
        id: 49,
        name: 'Self Leveling Suspension',
        category: 'Other',
        regex: /self[-\s]?leveling[-\s]?suspension/i,
        start_year: 1981,
        searchable: true,
    },
];
